export default __webpack_public_path__ + "static/nfp-logo-white-e25389b9ca4663283a67abc5812ec078.svg";